import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';

import PickupOrder from '../../../models/PickupOrder';
import { UserRoleType } from '../../../models/User';

import pickupOrderStyles from '../../pickupOrder/pickupOrder.module.css';
import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    textFieldPo: { 
      flex: '1 200px',  
    },
    textFieldDo: {
      flex: '1 200px',
    },
    textField: {
      '& textarea': {
        color: 'var(--primaryblue)',
        fontSize: '13px'
      },
      '& fieldset': {
        borderRadius: '20px'
      },
    },
  });

interface CommonOrderTopTextFieldsProps {
  classes: any;
  pickupOrder: PickupOrder;
  handleFieldsInput: Function;
  type: string;
  userRole: string;
};

const commonOrderTopTextFields = (props: CommonOrderTopTextFieldsProps) => {

  const { classes, pickupOrder } = props;

  const textFieldStyle: string = props.type === 'po' ?  [classes.textFieldPo, classes.textField].join(' ') : [classes.textFieldDo, classes.textField].join(' ') ;
  const disabled: boolean = props.userRole === UserRoleType.INCOGNITO ||  !props.pickupOrder.allowed_ops.update_awb_address;

  return (
    <div className={ pickupOrderStyles.topTextFields }>
        <form noValidate autoComplete="off">

          <div className={ pickupOrderStyles.flex } >

            <div className={ `${ commonStyles.inputLabelWrapper } ${ textFieldStyle } ${ commonStyles.mt0 }` } >
              <label className={ commonStyles.inputLabel }>Pick Up From </label>
              <TextField
                id="pickup-form"
                label=""
                multiline
                rows="3"
                rowsMax="3"
                value={ pickupOrder.pickup_from.full_address }
                onChange={ (event) => props.handleFieldsInput('pickup_from', event) }
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                disabled={ disabled }
              />
            </div>
          
            <div className={ `${ commonStyles.inputLabelWrapper } ${ textFieldStyle } ${ commonStyles.mt0 }` } >
              <label className={ commonStyles.inputLabel }> Deliver To</label>
              <TextField
                id="deliver-to"
                label=""
                placeholder={ disabled? undefined: "-- Enter Delivery Information" }
                multiline
                rows="3"
                rowsMax="3"
                value={ pickupOrder.deliver_to ? pickupOrder.deliver_to.full_address : '' }
                onChange={ (event) => props.handleFieldsInput('deliver_to', event) }
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                disabled={ disabled }
              />
            </div>

            <div className={ `${ commonStyles.inputLabelWrapper } ${ textFieldStyle } ${ commonStyles.mt0 }` } >
              <label className={ commonStyles.inputLabel }> Bill To </label>
              <TextField
                id="bill-to"
                label=""
                multiline
                rows="3"
                rowsMax="3"
                value={ pickupOrder.bill_to.full_address }
                onChange={ (event) => props.handleFieldsInput('bill_to', event) }
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                disabled={ disabled }
                />
            </div>
            
            { props.type === 'po' && 
              <div className={ `${ commonStyles.inputLabelWrapper } ${ textFieldStyle } ${ commonStyles.mt0 }` } >
                <label className={ commonStyles.inputLabel }> Endorse To </label>
                <TextField
                  id="endorse-to"
                  label=""
                  placeholder={ disabled? undefined: "-- Enter Endorse to Information" }
                  multiline
                  rows="3"
                  rowsMax="3"
                  value={ pickupOrder.endorse_to? pickupOrder.endorse_to.full_address : '' }
                  onChange={ (event) => props.handleFieldsInput('endorse_to', event) }
                  variant="outlined"
                  InputLabelProps={{ shrink: true } }
                  disabled={ disabled }
                />
              </div>
            }
          
        </div>
      </form>   
     </div>
  );
}

export default withStyles(styles)(commonOrderTopTextFields);